import React, { useEffect, useState } from "react";
import CardAddButton from "../button/cardAdd";
import { CreateNegdiOrderPaymentWithCard } from "../../functions/negdi/createNegdiOrderPaymentWithCard";
import { CreateNegdiCardPay } from "../../functions/negdi/createNegdiCardPay";
import { notification } from "antd";
import AskUserPin from "../modal/askUserPin";
import GetUserCards from "../../functions/user/getUserCards";
import { useUser } from "../../screens/user/context.js/userContext";
import { CreateNegdiOrderPayment } from "functions/negdi/createNegdiOrderPayment";
import AskUserPinSma from "components/modal/askUserPinSma";

const CardList = ({ userId, invoiceId, merchantId }) => {
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [cardData, setCardData] = useState(null);
  const { setPaying, setShowSuccess } = useUser();
  useEffect(() => {
    if (userId) {
      fetchCardIndos();
    }
  }, [userId]);
  const fetchCardIndos = async () => {
    setPaying("Картын мэдээлэл татаж байна...");
    const result = await GetUserCards(userId);
    setPaying(null);
    if (result && result.success) {
      return setCardData(result.data);
    }
  };
  const cardAdd = async () => {
    setPaying("Захиалга үүсгэж байна...");
    const payLoad = {
      invoiceId: invoiceId,
      amount: 100,
      userId: userId,
    };
    const response = await CreateNegdiOrderPayment(payLoad);
    setPaying(null);
    if (response && response.status) window.location.href = response.negdiurl;
  };
  const askApprove = (cardId) => {
    setShowApproveModal(true);
    setSelectedCardId(cardId);
  };
  const close = () => {
    setShowApproveModal(false);
  };
  const pay = async (pin) => {
    const cardId = selectedCardId;
    if (!cardId) return failed("Карт сонгоогүй байна!");
    setPaying("Захиалга үүсгэж байна...");
    const order = await CreateNegdiOrderPaymentWithCard(invoiceId, cardId, pin);
    //console.log('order:', order)
    if (!order || !order.tranid || !order.checkid)
      return failed("Захиалга үүсгэхэд алдаа гарлаа!");

    setPaying("Төлөлт хийж байна..");
    const autoPay = await CreateNegdiCardPay(
      order.id,
      cardId,
      userId,
      pin,
      pin === "SMA"
    );
    if (autoPay && autoPay.success) {
      notification.success({ message: "Амжилттай картын төлөлт хийгдлээ" });
      setShowSuccess(true);
    }

    setPaying(false);
    // setTimeout(() => {
    //   window.location.href = returnUrl;
    // }, 3000);
  };
  const failed = (message) => {
    notification.error({ message: message, description: message });
    setPaying(null);
  };
  return (
    <div className="cardList">
      {cardData &&
        cardData.map((card, index) => (
          <div
            key={index}
            onClick={() => askApprove(card.id)}
            className="flex justify-start w-full p-4 bg-gray-600 rounded-xl gap-2"
          >
            <img src={"/cardHas.png"} alt="card" className="cardImage" />
            <div className="cardDescBottom">
              <span className="text-md text-gray-200">{card.maskedpan}</span>
              <span className="text-center text-gray-200">
                valid : {card.expdate}
              </span>
            </div>
            <span className="instantPayByCard text-gray-100">Шууд төлөх</span>
          </div>
        ))}
      <CardAddButton onClick={cardAdd} />
      {showApproveModal && merchantId !== 2 && (
        <AskUserPin
          open={showApproveModal}
          close={close}
          userId={userId}
          merchantId={merchantId}
          verified={(e) => pay(e)}
        />
      )}
      {showApproveModal && merchantId === 2 && (
        <AskUserPinSma
          open={showApproveModal}
          close={close}
          userId={userId}
          merchantId={merchantId}
          verified={(e) => pay(e)}
        />
      )}
    </div>
  );
};

export default CardList;
